module.exports = __webpack_public_path__ + "img/LuckyWheel.71b3bf3e.png";